import React from "react";
import WarehouseCalculator from "./WarehouseCalculator";
import ProcessingCalculator from "./ProcessingCalculator";

export default function SubsidyCalculator() {
//   const [category, setCategory] = useState("farmer");
//   const [location, setLocation] = useState("general");
//   const [cost, setCost] = useState("");
//   const [result, setResult] = useState(null);

//   const getRate = () => {
//     if (category === "farmer") {
//       return location === "hilly" ? 0.3333 : 0.25;
//     }
//     if (category === "women") return 0.3333;
//     if (category === "cooperative") {
//       return location === "hilly" ? 0.3333 : 0.25;
//     }
//     if (category === "private") {
//       return location === "hilly" ? 0.25 : 0.15;
//     }
//   };

//   const getMaxLimit = () => {
//     if (category === "cooperative") return 37500000;
//     if (category === "private") return 18750000;
//     return 22500000;
//   };

//   const calculate = () => {
//     const rate = getRate();
//     const calculated = cost * rate;
//     const max = getMaxLimit();

//     const finalAmount = Math.min(calculated, max);

//     setResult({
//       rate: rate * 100,
//       calculated,
//       max,
//       finalAmount
//     });
//   };

  return (
    <>
      <div className="justify-items-center">
        <h2 className="text-center fw-bold mb-3">
NABARD Subsidy Calculator</h2>
        </div>

    <div className="calculator-wrapper">
  <WarehouseCalculator />
  <ProcessingCalculator />
</div>


{/* //     <div className="card">
//       <h2>Subsidy Calculator</h2>
// <p>Estimate the subsidy amount for your rural godown project</p>

//       <label>Category</label>
//       <select onChange={(e) => setCategory(e.target.value)}>
//         <option value="farmer">Individual Farmer / FPO</option>
//         <option value="women">Women / SC / ST</option>
//         <option value="cooperative">Cooperative</option>
//         <option value="private">Private Company</option>
//       </select>

//       <label>Location</label>
//       <select onChange={(e) => setLocation(e.target.value)}>
//         <option value="general">General Area</option>
//         <option value="hilly">Hilly / North East</option>
//       </select>

//       <label>Project Cost</label>
//       <input */}
{/* //         type="number"
//         value={cost}
//         onChange={(e) => setCost(e.target.value)}
//       />

//       <button onClick={calculate}>Calculate Subsidy</button>

//       {result && ( */}
{/* //         <div className="result">
//           <p>Subsidy Rate: {result.rate}%</p>
//           <p>Calculated Amount: ₹{result.calculated.toLocaleString()}</p>
//           <p>Maximum Eligible: ₹{result.max.toLocaleString()}</p>
//           <h3>Final Subsidy: ₹{result.finalAmount.toLocaleString()}</h3>
//         </div>
//       )}
//     </div> */}

</>
  );
}